/**
 * 人员小组管理路由配置
 */
const teamRoutes = {
  path: 'team',
  name: 'team',
  component: { template: '<router-view></router-view>' },
  children: [
    {
      path: 'list',
      name: 'teamList',
      component: () => import('./index.vue'),
      meta: {
        navtabTitle: '人员小组管理',
        isCache: true,
        ignoreDiff: [],
        isIframe: false
      }
    }
  ]
};

export default teamRoutes;
